import { render, staticRenderFns } from "./InsuranceAuthorizationTableList.vue?vue&type=template&id=510e7584&scoped=true&"
import script from "./InsuranceAuthorizationTableList.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationTableList.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAuthorizationTableList.vue?vue&type=style&index=0&id=510e7584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e7584",
  null
  
)

export default component.exports